import { render, staticRenderFns } from "./AccidentHistoryNew.vue?vue&type=template&id=4fd2789c&scoped=true&lang=pug&"
import script from "./scripts/AccidentHistoryNew.js?vue&type=script&lang=js&"
export * from "./scripts/AccidentHistoryNew.js?vue&type=script&lang=js&"
import style0 from "./AccidentHistoryNew.vue?vue&type=style&index=0&id=4fd2789c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd2789c",
  null
  
)

export default component.exports